import angular from 'angular';

export class MainHeaderComponent {

    /*@ngInject*/
    constructor(Auth, $location) {
        this.Auth = Auth;
        this.isLoggedInSync = Auth.isLoggedInSync;
        this.isAdminSync = Auth.isAdminSync;
        this.$location = $location;
        this.user = Auth.getCurrentUserSync;
    }

    isActive(route) {
        return route === this.$location.path();
    }
}

export default angular.module('directives.main-header', [])
    .component('mainHeader', {
        template: require('./main-header.html'),
        controller: MainHeaderComponent
    })
    .name;



// WEBPACK FOOTER //
// ./client/components/main-header/main-header.component.js